'use client';

import React from 'react';

import { TasticProps } from 'frontastic/tastics/types';
import {CmsMasterContainerV2Props } from 'components/commercetools-ui/organisms/content/cms-master-container-v2';
import CmsMasterContainerV2 from 'components/commercetools-ui/organisms/content/cms-master-container-v2';
import BlogPostSchema from 'components/commercetools-ui/organisms/blogpost-schema';

const CmsMasterContainerV2Tastic = ({ data, seoData, logoUrl }: TasticProps<CmsMasterContainerV2Props>) => {
  const dataSource = data?.data?.dataSource;
  //Blog pages (renovation guides) opt in via the entry's Blog Meta Data; headline/description still
  //come from the Frontastic Studio page SEO settings, as on the legacy renovation-guide tastic.
  const blogMetaData = dataSource?.blog_meta_data;
  return (
    <>
      {blogMetaData?.is_blog_page && (
        <BlogPostSchema
          url={dataSource?.url}
          datePublished={blogMetaData?.date_published}
          imageUrl={blogMetaData?.featured_image?.url}
          seoData={seoData}
          logoUrl={logoUrl}
        />
      )}
      <CmsMasterContainerV2 data={dataSource} />
    </>
  );
};

export default CmsMasterContainerV2Tastic;
